import { APPOINTMENTS_API_URL } from 'constants/ApiConstants';
import * as interventionActionTypes from 'modules/interventions/actionTypes';

import * as types from '../actionTypes';

/**
 * Get All appointments
 * @param {Object} params
 * @param {string} params.dealerId
 */
export const fetchAppointments = (params, meta = {}) => ({
  type: types.FETCH_APPOINTMENTS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${APPOINTMENTS_API_URL}`,
      params: {
        ...params,
        projection: 'page',
      },
    },
  },
  meta,
});

export const fetchAppointmentsSuccess = (appointments, meta = {}) => ({
  type: types.FETCH_APPOINTMENTS_SUCCESS,
  payload: appointments,
  meta,
});

export const fetchAppointmentsFailure = (message, meta = {}) => ({
  type: types.FETCH_APPOINTMENTS_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const fetchAppointment = (id, meta = {}) => ({
  type: types.FETCH_APPOINTMENT_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${APPOINTMENTS_API_URL}/${id}`,
      params: {
        projection: 'details',
      },
    },
    id,
  },
  meta,
});

export const createAppointment = (appointment, meta = {}) => ({
  type: types.POST_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENTS_API_URL}/`,
      data: appointment,
    },
  },
  meta,
});

export const deleteRequest = (id, meta = {}) => ({
  type: types.DELETE_REQUEST,
  payload: {
    request: {
      method: 'DELETE',
      url: `${APPOINTMENTS_API_URL}/${id}`,
      params: {
        id,
      },
    },
  },
  meta,
});

export const deleteSuccess = (id, meta = {}) => ({
  type: types.DELETE_SUCCESS,
  payload: id,
  meta,
});

export const patchStatusRequest = (id, status, meta = {}) => ({
  type: types.PATCH_STATUS_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${APPOINTMENTS_API_URL}/${id}/status`,
      data: {
        status,
      },
    },
  },
  meta,
});

export const putRequest = (appointment, meta = {}) => ({
  type: types.PUT_REQUEST,
  payload: {
    request: {
      method: 'PUT',
      url: `${APPOINTMENTS_API_URL}/${appointment.id}`,
      data: appointment,
    },
  },
  meta,
});

export const putSuccess = (appointment, meta = {}) => ({
  type: types.PUT_SUCCESS,
  payload: appointment,
  meta,
});

export const putFailure = (message, meta = {}) => ({
  type: types.PUT_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const postSendRequest = ({ id, channels, force }, meta = {}) => ({
  type: interventionActionTypes.POST_SEND_BY_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENTS_API_URL}/${id}/send`,
      data: { channels, force },
    },
  },
  meta,
});

export const setPageSize = size => ({
  type: types.SET_PAGE_SIZE,
  payload: {
    size,
  },
});

// Filter actions
export const setAppointmentFilter = (field, value) => ({
  type: types.SET_APPOINTMENT_FILTER,
  payload: { field, value },
});

export const clearAppointmentFilters = () => ({
  type: types.CLEAR_APPOINTMENT_FILTERS,
});

export const removeAppointmentFilter = (field, value) => ({
  type: types.REMOVE_APPOINTMENT_FILTER,
  payload: { field, value },
});

export const navigateToDetails = id => ({
  type: types.NAVIGATE_TO_DETAILS,
  payload: {
    id,
  },
});
